export default "/assets/images/preloader.gif?14d740b6ee64510747b03b411d46f200";